// scroll fade animation
export function scrollAnimation() {
    let isMobileRes = window.innerWidth < this.phablet;
    let winHeight = $(window).height();
    let offset = $(document).scrollTop();

    let data = [...document.querySelectorAll(".js-animate")].map(item => {
        item.classList.add("invisible");
        return {
            node: item,
            classes: item.getAttribute("data-animate").split(" "),
            offset: $(item).offset().top
        };
    });

    window.addEventListener("resize", () => {
        setTimeout(() => {
            data = data.map(item => {
                item.offset = $(item.node).offset().top;
                return item;
            });
            winHeight = $(window).height();
            isMobileRes = window.innerWidth < this.phablet;
        }, 300);
    });

    function animate(offset = 0) {
        if (!isMobileRes) {
            data.forEach(item => {
                let botScroll = offset + winHeight;
                if (botScroll < item.offset) {
                    item.classes.forEach(cls => {
                        item.node.classList.remove(cls);
                    });
                } else if (botScroll >= item.offset) {
                    item.classes.forEach(cls => {
                        item.node.classList.add(cls);
                    });
                }
            });
        } else if (isMobileRes) {
            data.forEach(item => {
                item.classes.forEach(cls => {
                    item.node.classList.add(cls);
                });
            });
        }
    }

    animate(offset);
    window.addEventListener("scroll", () => {
        offset = $(document).scrollTop();
        animate(offset);
    });
}

// scroll first section
export function introSection() {
    let isScrollInited = false;
    let headerHeight = $(".js-header").outerHeight();
    let phablet = this.phablet;
    if (!this.isTouch) {
        function actions() {
            let isPhablet = window.innerWidth < phablet;
            if (!isPhablet && !isScrollInited) {
                $.scrollify({
                    section: ".js-scroll-section",
                    setHeights: false,
                    updateHash: false,
                    // interstitialSection: ".footer",
                    offsetHeight: headerHeight,
                    afterResize() {
                        headerHeight = $(".js-header").outerHeight();
                        $.scrollify.setOptions({offsetHeight: headerHeight});
                    }
                });
                isScrollInited = true;
            } else if (isPhablet && isScrollInited) {
                isScrollInited = false;
                $.scrollify.destroy();
            }
        }
     /*   actions();
        window.addEventListener("resize", () => {
            setTimeout(() => {
                actions();
            }, 300);
        });*/
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollAnimations.js